<template>
    <b-overlay :show="loading || typeLoading" opacity="0.2">
        <b-modal id="edit-score" size="lg" title="Puantaj Düzenle" scrollable no-close-on-esc no-close-on-backdrop>
            <monthly-update-score v-model="score" :types="types" :display-mode="displayMode" v-on:refresh="refresh"></monthly-update-score>
            <template #modal-footer>
                <v-executer :disabled="score.Locked" text="Güncelle" :action="updateScore" :loading="presaving">
                    <div v-if="score.Locked" class="d-flex align-items-center g-50">
                        <feather-icon icon="LockIcon"></feather-icon>
                        Puantaj Kilitli
                    </div>
                    <template v-else>Güncelle</template>
                </v-executer>
            </template>
        </b-modal>

        <b-modal v-if="additional.SIRA_NO == 35 && additional.TIP==1" id="additional" size="sm" :title="(additional.SIRA_NO == 35 && additional.TIP==1) ? 'Fazla Mesai Düzenle' : 'Hafta Tatili Mesaisi Düzenle'" scrollable no-close-on-esc no-close-on-backdrop>
            <monthly-additional v-model="additional"></monthly-additional>
            <template #modal-footer><v-executer text="Kaydet" :action="createAdditional" :loading="additionalCreating"></v-executer></template>
        </b-modal>

        <b-modal id="score-errors" body-class="p-75" :title="scoreErrors.EmployeeName ? `Puantaj Hataları - ${scoreErrors.EmployeeName}` : 'Puantaj Hataları'" hide-footer scrollable no-close-on-esc no-close-on-backdrop>
            <monthly-score-error :errors="scoreErrors.Errors" :month="[showingMonth >= 10 ? showingMonth : [0,showingMonth].join(''),showingYear].join('/')"></monthly-score-error>
        </b-modal>

        <div class="row px-1 pt-1">
            <div class="col-md-1 mb-1 mb-md-0">
                <select class="form-control" v-model="month">
                    <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                </select>
            </div>
            <div class="col-md-1 mb-1 mb-md-0">
                <select class="form-control" v-model="year">
                    <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                </select>
            </div>
            <div class="col-md-auto mb-1 mb-md-0" v-if="exitAction == null">
                <select class="form-control bg-img-none" v-model="branchType">
                    <option value="O">Org. Şube</option>
                    <option value="S">SGK Şube</option>
                </select>
            </div>
            <div class="col-md-2 mb-1 mb-md-0" v-if="exitAction == null && branchType == 'O'">
                <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
            </div>
            <div class="col-md-2 mb-1 mb-md-0" v-if="exitAction == null && branchType == 'S'">
                <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
            </div>
            <div class="col-md-2 mb-1 mb-md-0" v-if="exitAction == null">
                <b-input-group class="input-group-merge v-table-search-input">
                    <template #prepend>
                        <b-input-group-text >
                            <feather-icon icon="SearchIcon"></feather-icon>
                        </b-input-group-text>
                    </template>
                    <b-form-input v-model="searchValue" v-on:keyup.enter="checkUnsavedAndGetAll" placeholder="Ara..." ></b-form-input>
                </b-input-group>
            </div>
            <div class="col-md-auto mb-1 mb-md-0">
                <select class="form-control" v-model="displayMode">
                    <option v-for="opt in displayModeOptions" :key="opt.value" :value="opt.value">{{opt.text}}</option>
                </select>
            </div>
            <div class="col-md-auto mb-1 mb-md-0">
                <button class="btn btn-success btn-block" v-on:click="checkUnsavedAndGetAll">
                    Sorgula
                </button>
            </div>
        </div>

        <div class="sticky-status border-bottom pt-25">
            <div :class="['date-header text-muted font-weight-bolder px-1 pt-1',{'pb-1':(types || []).length == 0}]">
                <span class="material-icons-round text-secondary">calendar_month</span>
                {{showingMonth >= 10 ? showingMonth : [0,showingMonth].join('')}}/{{showingYear}}
                <span v-if="displayMode === 'utc_plus_3'" class="badge badge-warning ml-50">UTC+3</span>
            </div>

            <!-- <div class="mx-75 mb-75 mt-75">
                <div class="type rounded px-50 py-25 d-flex align-items-center d-inline-flex m-25" :class="`type-bg-${type.Color}`" v-for="type in (types || [])" :key="type.Code">
                    <div class="d-flex align-items-center justify-content-center font-weight-bolder mr-50" :class="`type-${type.Color}`">{{type.Code}}</div>
                    <span class="pr-25">{{type.Name}}</span>
                </div>
            </div> -->

            <div class="px-1" v-if="(types || []).length">
                <vue-perfect-scrollbar>
                    <div class="d-flex g-25 mb-75 mt-75 w-100" >
                        <div v-for="(type,index) in types" :key="index" class="type d-flex align-items-center py-25 pl-25 pr-50 text-nowrap" :class="`type-bg-${type.Color}`">
                            <div class="d-flex align-items-center justify-content-center font-weight-bolder mr-50" :class="`type-${type.Color}`">{{type.Code}}</div>
                            {{$safe(type,'Name')}}
                        </div>
                    </div>
                </vue-perfect-scrollbar>
            </div>
        </div>

        <div class="row justify-content-between align-items-center my-1 mx-50">
            <!-- <div class="col-md-4 mb-1 mb-md-0">
                <div class="row">
                    <div class="col-md-6 mb-1 mb-md-0">
                        <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
                    </div>
                    <div class="col-md-6 mb-1 mb-md-0">
                        <select class="form-control" v-model="filterError">
                            <option :value="null">Tümü</option>
                            <option :value="true">Hatalı</option>
                            <option :value="false">Hatasız</option>
                        </select>
                    </div>
                </div>
            </div> -->
            <div class="col-auto mb-1 mb-md-0">
                <div class="d-flex align-items-center">
                    <button class="btn btn-sm btn-primary mr-50" v-on:click="selectAll" v-if="exitAction == null">Tümünü Seç</button>
                    <b-form-checkbox v-model="showTachographTime" inline name="check-button" switch>
                        Takograf Sürelerini Göster
                    </b-form-checkbox>
                    <b-form-checkbox v-model="showMayinlama" inline name="check-button" switch>
                        Mayınlama Olasılıklarını Göster
                    </b-form-checkbox>
                </div>
            </div>

            <!-- <div class="col-md-3" v-if="exitAction == null">
                <b-input-group class="input-group-merge v-table-search-input">
                    <template #prepend>
                        <b-input-group-text >
                            <feather-icon icon="SearchIcon"></feather-icon>
                        </b-input-group-text>
                    </template>
                    <b-form-input v-on:keyup="search" v-model="searchValue" placeholder="Ara..." ></b-form-input>
                </b-input-group>
            </div> -->
        </div>
        <vue-perfect-scrollbar tag="div" class="overflow-hidden">
            <table class="table table-sm table-hovered bordered-header mb-1 score-table">
                <thead>
                    <tr>
                        <th rowspan="2" class="align-middle">Durum</th>
                        <th rowspan="2" class="column-sticky align-middle">Personel</th>
                        <th rowspan="2" class="align-middle text-nowrap">Kimlik Numarası</th>
                        <th rowspan="2" class="align-middle text-nowrap">Org. Şube</th>
                        <th rowspan="2" class="align-middle text-nowrap">SGK Şube</th>
                        <th class="text-nowrap" v-for="day in daysOfMonth" :key="day" :colspan="values.length" >
                            <template v-if="getDayIsHoliday(day)">
                                <div class="d-flex align-items-center text-danger" v-b-tooltip.noninteractive.hover.bottom="getDayIsHoliday(day)">
                                    {{day}} {{ getDayName(day) }}
                                    <feather-icon icon="InfoIcon" class="ml-50"></feather-icon>
                                </div>
                            </template>
                            <template v-else>
                                {{day}} {{ getDayName(day) }}
                            </template>
                        </th>
                        <th class="bg-light-secondary" :colspan="(c_types || []).length">Özet</th>
                        <th rowspan="2" class="align-middle text-nowrap" v-b-tooltip.noninteractive.hover.bottom="'NORMAL FAZLA MESAİ'">FM-N (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap text-info" v-b-tooltip.noninteractive.hover.bottom="'AYLIK BAZDA MANUEL EKLENEN FAZLA MESAİ'">FM-E (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap" v-b-tooltip.noninteractive.hover.bottom="'POLİTİK FAZLA MESAİ'">FM-P (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap" v-b-tooltip.noninteractive.hover.bottom="'DENKLEŞTİRMEDEN KALAN FAZLA MESAİ'">FM-D (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap" v-b-tooltip.noninteractive.hover.bottom="'TOPLAM FAZLA MESAİ'">FM-T (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap text-warning" v-b-tooltip.noninteractive.hover.bottom="'YILLIK TOPLAM FAZLA MESAİ'">YTFM (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap text-secondary" v-b-tooltip.noninteractive.hover.bottom="'HAFTA TATİLİ MESAİSİ'">HTM (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap" v-b-tooltip.noninteractive.hover.bottom="'GENEL TATİL MESAİSİ'">GTM (Saat)</th>
                        <!-- <th rowspan="2" class="align-middle text-nowrap" v-b-tooltip.noninteractive.hover.bottom="'TOPLAM ÇALIŞMA GÜNÜ'">TÇG (Gün)</th> -->
                        <th rowspan="2" class="align-middle text-nowrap" v-b-tooltip.noninteractive.hover.bottom="'GÜN BAZLI TOPLAM ÇALIŞMA SAATİ'">GTÇS (Saat)</th>
                        <th rowspan="2" class="align-middle text-nowrap" v-b-tooltip.noninteractive.hover.bottom="'TAKOGRAF BAZLI TOPLAM ÇALIŞMA SAATİ'">TTÇS (Saat)</th>
                    </tr>
                    <tr>
                        <template v-for="day in daysOfMonth">
                            <th v-for="(value,index) in values" class="text-center" :key="day + index" v-b-tooltip.noninteractive.hover.bottom="value.text" :class="value.color">{{value.short}}</th>
                        </template>
                        <template v-for="type in c_types">
                            <th  class="align-middle text-nowrap">{{ $safe(type,'Name') }}</th>
                        </template>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="d in serverData.filter(s => s.Configured)" :key="d.DriverCardNumber">
                        <td class="text-nowrap">
                            <div class="d-flex align-items-center justify-content-center">
                                <span class="material-icons-outlined mr-50 text-secondary" v-b-tooltip.noninteractive.hover.right="'İlgili şube ve ay için puantaj kilitlidir.'" v-if="d.Locked">lock</span>
                                <span class="material-icons-outlined mr-50 text-danger c-pointer" v-on:click="showErrors(d)" v-else-if="d.DayErrors.length" v-b-tooltip.noninteractive.hover.right="`Toplam ${d.DayErrors.length} adet puantaj hatası bulunmaktadır.`" >report_gmailerrorred</span>
                                <span class="material-icons-outlined mr-50 text-success" v-b-tooltip.noninteractive.hover.right="'Sürücü puantaj bilgisi kaydedilebilir.'" v-else>check_circle</span>
                            </div>
                        </td>
                        <td class="text-nowrap column-sticky">
                            <div class="d-flex align-items-center">
                                <b-form-checkbox :disabled="d.DayErrors.length != 0 || d.Locked" v-model="d.Selected">
                                    {{$safe(d,'Employee.FirstName') &&  $safe(d,'Employee.LastName') ? [$safe(d,'Employee.FirstName'),$safe(d,'Employee.LastName')].join(' ') : d.DriverFullName}}
                                </b-form-checkbox>
                            </div>
                        </td> 
                        <td>
                            {{$safe(d,'Employee.IdentityNumber') || '-'}}
                        </td>
                        <td v-b-tooltip.hover.bottom.html="[
                            '<div class=\'text-left\'>',
                            [`Giriş: ${ d.OStartDateStr || '-' }`,`Çıkış: ${ d.OEndDateStr || '-' }`,].join('<br/>'),
                            '</div>'
                            ].join('')"">
                            {{$safe(d,'OBranch.Name') || '-'}}
                        </td>
                        <td v-b-tooltip.hover.bottom.html="[
                            '<div class=\'text-left\'>',
                            [`Giriş: ${ d.SGKStartDateStr || '-' }`,`Çıkış: ${ d.SGKEndDateStr || '-' }`,].join('<br/>'),
                            '</div>'
                            ].join('')"">
                            {{$safe(d,'SGKBranch.Name') || '-'}}
                        </td>
                        <template v-for="(day,rowIndex) in daysOfMonth">
                            <template v-if="$safe(d.Days[day],'DayIsBefore') == false">
                                <td :colspan="values.length" :key="d.DriverCardNumber + day + 'is-before'" class="text-center align-middle border-right">
                                    <span class="material-icons-round d-block text-muted" v-b-tooltip.noninteractive.hover.bottom="`${day} tarihi için henüz çalışma kaydı girilemez.`">event_busy</span>
                                </td>
                            </template>
                            <template v-else-if="$safe(d.Days[day],'Working')">
                                <template v-for="(value,index) in values">
                                    <td     class="text-center cell-group position-relative" 
                                            v-on:click="edit(d,day,d.Days[day])" 
                                            :title="day" 
                                            :key="d.DriverCardNumber + day + index" 
                                            :data-cell-group="[d.Employee.IdentityNumber || '',day,rowIndex].join('-')" 
                                            :data-index="index" 
                                            @mouseover="hover" 
                                            @mouseleave="unhover" 
                                            :class="[
                                                $safe(d.Days[day][value.value],'Type.Color') ? ['type',$safe(d.Days[day][value.value],'Type.Color')].join('-') : null,
                                                d.Days[day].HasConflict ? `score-error-${index}`:null,
                                                d.Days[day].PossibleHT && showMayinlama ? `score-warning-${index}`:null,
                                                d.Days[day].PossibleHTM && showMayinlama ? `score-info-${index}`:null,
                                                d.Days[day].RSWarning ? `score-secondary-${index}`:null,
                                                d.Days[day].IhbarOneli ? `score-ihbar-${index}`:null,
                                                value.value == 'Score' ? 'font-weight-bolder border-right' : null,
                                                'text-nowrap'
                                            ]">
                                        <strong v-if="showTachographTime && index == 0">{{ $safe(d.Days[day],'TachographNew.OriginalTacho') }}&nbsp;</strong>
                                        {{$safe(d.Days[day][value.value],'Type.Code') || "-"}}
                                        <template v-if="value.value == 'Score'">
                                            <template v-if="$safe(d.Days[day],'HTM') != null">
                                                <span class="small-box type-gray">H</span>
                                            </template>
                                            <template v-else-if="$safe(d.Days[day],'GTMFM') != null || $safe(d.Days[day],'GTM') != null">
                                                <span class="small-box type-purple">RT</span>
                                            </template>
                                        </template>
                                    </td>
                                </template>
                            </template>
                            <template v-else>
                                <td :key="d.DriverCardNumber + day" :colspan="values.length" v-on:click="$safe(d.Days[day],'HasNoData') == false && edit(d,day,d.Days[day])" class="bg-light text-center align-middle border-right c-pointer">
                                    <span class="material-icons-round d-block text-secondary" v-if="$safe(d.Days[day],'HasNoData') == false" v-b-tooltip.noninteractive.hover.bottom="`${day} tarihinde sigorta kaydı olmadığı halde takograf veya günlük çalışma kaydı bulunmaktadır.`">error_outline</span>
                                </td>
                            </template>
                        </template>
                        <template v-for="(t,i) in c_types">
                            <td>{{ $safe(d,`Totals.${t.TIP}${t.SIRA_NO}`) || 0 }}</td>
                        </template>
                        <td>
                            <div class="d-flex align-items-center">
                                {{$safe(d,'FMStr') || '0'}}
                            </div>
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <button :disabled="d.Locked" v-on:click="editAdditional(d,1,35,'FM')" class="btn btn-xs mr-25 btn-icon btn-flat-primary" v-b-tooltip.noninteractive.hover.bottomright title="Fazla Mesai Düzenle">
                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                </button>
                                <span class="font-weight-bolder text-nowrap">{{$safe(d,'MonthlyFMStr') || '0'}}</span>
                            </div>
                        </td>
                        <td>
                            {{$safe(d,'PFMStr') || '0'}}
                        </td>
                        <td>
                            {{$safe(d,'DenklestirmedenKalanStr') || '0'}}
                        </td>
                        <td>
                            {{$safe(d,'TotalFMStr') || '0'}}
                        </td>
                        <td>
                            {{$safe(d,'YearlyFMStr') || '0'}}
                        </td>
                        <td>
                            <div class="d-flex align-items-center">
                                <!-- <button :disabled="d.Locked" v-on:click="editAdditional(d,1,10,'GT')" class="btn btn-xs mr-25 btn-icon btn-flat-secondary" v-b-tooltip.noninteractive.hover.bottomright title="Hafta Tatili Mesaisi Düzenle">
                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                </button> -->
                                <span class="font-weight-bolder text-nowrap">{{$safe(d,'TotalHTMStr') || '0'}}</span>
                            </div>
                        </td>
                        <td>
                            {{$safe(d,'GTMStr')}}
                        </td>
                        <!-- <td>
                            {{$safe(d,'TotalNDay')}}
                        </td> -->
                        <td>
                            {{$safe(d,'TotalN')}}
                        </td>
                        <td>
                            {{$safe(d,'TotalNHour')}}
                        </td>
                    </tr>
                    <tr v-if="(serverData || []).length == 0">
                        <td class="text-center" colspan="122">Herhangi bir veri bulunamadı.</td>
                    </tr>
                </tbody>
            </table>
        </vue-perfect-scrollbar>
        <div class="d-flex g-50 px-50">
            <div class="cell-error-indicator px-75 py-25 rounded text-danger d-flex align-items-center g-50">
                <span class="material-icons-outlined cell-indicator-icon">cancel</span>
                Puantaj Hatası
            </div>
            <div class="cell-secondary-indicator px-75 py-25 rounded text-secondary d-flex align-items-center g-50">
                <span class="material-icons-outlined cell-indicator-icon">report</span>
                Sakıncalı Puantaj
            </div>
            <div class="cell-warning-indicator px-75 py-25 rounded text-warning d-flex align-items-center g-50" v-if="showMayinlama">
                <span class="material-icons-outlined cell-indicator-icon">info</span>
                Hafta Tatili Verilebilir
            </div>
            <div class="cell-info-indicator px-75 py-25 rounded text-info d-flex align-items-center g-50" v-if="showMayinlama">
                <span class="material-icons-outlined cell-indicator-icon">info</span>
                Hafta Tatili Mesaisi Verilebilir
            </div>
            <div class="cell-ihbar-indicator px-75 py-25 rounded text-info d-flex align-items-center g-50" v-if="exitAction">
                <span class="material-icons-outlined cell-indicator-icon">info</span>
                İhbar Öneli Süresi
            </div>
        </div>
        <div class="d-flex justify-content-between p-1">
            <div class="d-flex align-items-center text-nowrap per-page">
                <span>Toplam {{total}} kayıt arasından</span>
                <select class="form-control form-control-sm mx-50" v-model="perPage">
                    <option v-for="pp in perPages" :value="pp" :key="pp">{{pp}}</option>
                </select>
                <span>gösteriliyor.</span>
            </div>
            <b-pagination :total-rows="total" v-model="currentPage" :per-page="perPage" v-on:change="$nextTick(()=>{ checkUnsavedAndGetAll() })" class="mb-0">
                <template #page="{page}">
                    {{page}}<span class="text-secondary">{{hasUnsavedItem(page) ? '*':''}}</span>
                </template>
            </b-pagination>
        </div>
        <div class="text-right px-1 pb-1 pt-50">
            <v-executer :loading="saving" :action="create" :disabled="c_selected == 0" :text="`Seçilenleri (${c_selected} Puantaj) Kaydet`"></v-executer>
        </div>
    </b-overlay>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations' 
import { BCard,BOverlay,VBTooltip, BFormCheckbox,BPagination,BInputGroupText, BInputGroup, BFormInput } from 'bootstrap-vue'
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import MonthlyUpdateScore from './MonthlyUpdateScore.vue'
import MonthlyScoreError from './MonthlyScoreError.vue'
import SystemData from '@/api/system-data'
import MonthlyAdditional from './MonthlyAdditional.vue'

export default {
    props:{
        months:Array,
        typeLoading:{
            type:Boolean,
            default:false
        },
        types:{
            type:Array,
            default:()=>[]
        },
        branches:{
            type:Array,
            default:()=>[]
        },
        sbranches:{
            type:Array,
            default:()=>[]
        },
        exitAction:[Object, null]
    },
    components:{
        BCard,
        BOverlay,
        VuePerfectScrollbar,
        MonthlyUpdateScore,
        MonthlyScoreError,
        BFormCheckbox,
        BPagination,
        BInputGroupText, 
        BInputGroup, 
        BFormInput,
        MonthlyAdditional
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    data() {
        return {
            loading:false,
            saving:false,
            serverData:[],
            baseServerData:[],
            year:null,
            years:[],
            showingYear:null,
            showingMonth:null,
            month:null,
            daysOfMonth:[],
            total:1,
            currentPage:1,
            perPage:10,
            perPages:[10,20,30,40],
            branch:null,
            sbranch:null,
            holidays:[],
            showTachographTime:false,
            showMayinlama:false,
            branchType:'O',
            values:[
                // {
                //     value:"Seyir",
                //     text:"Coğrafi Sistem Verisi",
                //     short:"C",
                //     color:"text-primary"
                // },
                {
                    value:"TachographNew",
                    text:"Takograf",
                    short:"T",
                    color:"text-secondary"
                },
                {
                    value:"DailyCheckStatus",
                    text:"Günlük Puantaj",
                    short:"G",
                    color:"text-warning"
                },
                {
                    value:"Score",
                    text:"Maaşa Esas Puantaj",
                    short:"M",
                    color:"text-success"
                },
            ],
            additional:{
                EmployeeId:null,
                Month:null,
                Year:null,
                Time:null,
                SystemCalculated:null,
                TIP:null,
                SIRA_NO:null,
                SystemCode:null,
                BranchId:null,
                SGKJobNoticeId:null
            },
            additionalCreating:false,
            score:{
                Driver:null,
                Employee:null,
                Day:{
                    Date:null,
                    Tachograph:{Type:{Code:null},All:null,AllNew:null},
                    Seyir:{Type:{Code:null},All:null},
                    DailyCheckStatus:{Type:{Code:null}},
                    Score:{Type:{Code:null}},
                },
                WorkedTime:null,
                WorkedTimeNew:null,
                GTM: null,
                NightWorkedTime:null,
                CachedNightWorkedTime:null,
                AdditionalTime:null,
                Holiday: false,
                SGKEksikGunId:null,
                IsGTM:false,
                IsHTM:false,
                IsArife:false,
                CanArife:false,
                HTM:null,
                GTMFM: null,
                Locked:false,
                BranchId:null,
                SGKJobNoticeId:null,
            },
            scoreErrors:{
                EmployeeName:null,
                Errors:[]
            },
            searchValue:null,
            searchTimer:null,
            filterError:null,
            presaving:false,
            displayMode:'utc',
            displayModeOptions:[
                { value: 'utc', text: 'UTC Gösterimi' },
                { value: 'utc_plus_3', text: 'UTC+3 Gösterimi' }
            ],
        }
    },
    mounted(){
        this.getHolidays()
        this.getCurrentYear()
        this.configureYears()
        this.getCurrentMonth()
        this.configureDaysOfMonth(Date.now())
        if(this.exitAction != null){
            this.getAllMonthly()
        }
    },
    watch:{
        exitAction(n,o){
            if(n != null && o == null){
                this.getAllMonthly()
            }
        }
    },
    methods:{
        refresh(){
            this.getAllMonthly()
            this.$hideModal('edit-score')
        },
        getMessage(mes){
            return mes
        },
        getDayIsHoliday(d){
            return this.holidays.find(h=>moment(d,'DD.MM.YYYY').isBetween(moment(h.Start,'YYYY-MM-DD'),moment(h.End,'YYYY-MM-DD'),null,"[)"))?.Name || null
        },
        getDayHolidayDetail(d){
            return this.holidays.find(h=>moment(d,'DD.MM.YYYY').isBetween(moment(h.Start,'YYYY-MM-DD'),moment(h.End,'YYYY-MM-DD'),null,"[)")) || null
        },
        getHolidays(){
            SystemData.GetHolidays().then(res=>{
                this.holidays = res.data?.Data?.items?.map(h=>{
                    return {
                        Start:h.start.date ? moment(h.start.date,'YYYY-MM-DD').format('YYYY-MM-DD') : null,
                        End:h.end.date,
                        Name:h.summary,
                        IsArife:h.summary?.toLowerCase().includes('arife')
                    }
                }) || []
            })
        },
        getDayName(day){
            return moment(day,'DD.MM.YYYY').locale('tr').format('ddd')
        },
        // search(){
        //     function search(){
        //         clearTimeout(this.searchTimer)
        //         this.searchTimer = setTimeout(()=>{ 
        //             this.$emit('search',this.searchValue)
        //             this.getAllMonthly() 
        //         },350)
        //     }
        //     clearTimeout(this.searchTimer)
        //     this.searchTimer = setTimeout(()=>{ search.call(this) },350)
        // },
        clearForm(){
            this.score.Driver = null
            this.score.Day.Date = null
            this.score.Day.Tachograph.Type.Code = null
            this.score.Day.Tachograph.All = null
            this.score.Day.Tachograph.AllNew = null
            this.score.Day.Seyir.Type.Code = null
            this.score.Day.Seyir.All = null
            this.score.Day.DailyCheckStatus.Type.Code = null
            this.score.Day.Score.Type.Code = null
            this.score.Employee = null
            this.score.WorkedTime = null
            this.score.NightWorkedTime = null
            this.score.AdditionalTime = null
            this.score.CachedNightWorkedTime = null
            this.score.GTM = null
            this.score.Holiday = false
            this.score.SGKEksikGunId = null
            this.score.IsHTM = null
            this.score.IsGTM = null
            this.score.IsArife = null
            this.score.CanArife = null
            this.score.HTM = null
            this.score.GTMFM = null
            this.score.Locked = null
            this.score.BranchId = null
            this.score.SGKJobNoticeId = null
        }, 
        edit(driver,day,dayData){
            this.clearForm()
            this.score.Driver = driver
            this.score.Employee = driver
            this.score.Day.Date = day
            this.score.Day.Tachograph.Type.Code = dayData.Tachograph?.Type?.Code || null
            this.score.Day.Tachograph.All = dayData.Tachograph
            this.score.Day.Tachograph.AllNew = dayData.TachographNew
            if(!dayData.TachographNew.Type){
                this.score.Day.Tachograph.AllNew = {
                    ...this.score.Day.Tachograph.AllNew,
                    Type:{
                        Id:null,
                        Code:null,
                        Name:null,
                        Color:null,
                        TIP:null,
                        SIRA_NO:null,
                    }
                }
            }
            this.score.Day.Seyir.Type.Code = dayData.Seyir?.Type?.Code || null
            this.score.Day.Seyir.All = dayData.Seyir
            this.score.Day.DailyCheckStatus.Type.Code = dayData.DailyCheckStatus?.Type?.Code || null
            this.score.Day.Score.Type.Code = dayData.Score?.Type?.Code || null
            this.score.WorkedTime = dayData.PresaveWorkedTime || dayData.WorkedTime || null
            this.score.WorkedTimeNew = dayData.TachographNew.N
            this.score.NightWorkedTime = dayData.TachographNew.NightWorkTime
            this.score.CachedNightWorkedTime = structuredClone(dayData.PresaveNightWorkedTime || dayData.NightWorkedTime || null)
            this.score.AdditionalTime = dayData.AdditionalTime
            this.score.Holiday = this.getDayIsHoliday(day)
            this.score.GTM = dayData.GTM
            this.score.SGKEksikGunId = dayData.SGKEksikGunId
            this.score.IsHTM = dayData.HTM == null ? false : true
            this.score.IsGTM = dayData.GTMFM == null && dayData.GTM == null ? false : true
            this.score.IsArife = dayData.IsArife != null ? dayData.IsArife : (this.getDayHolidayDetail(day)?.IsArife || false)
            this.score.CanArife = this.getDayHolidayDetail(day)?.IsArife || false
            this.score.HTM = dayData.HTM
            this.score.GTMFM = dayData.GTMFM
            this.score.Locked = driver.Locked
            this.score.BranchId = driver.OBranch?.Id || null
            this.score.SGKJobNoticeId = driver.SGKJobNoticeId || null,
            this.$showModal('edit-score')
        },
        showErrors(driver){
            this.scoreErrors = []
            this.scoreErrors.EmployeeName = [driver.Employee?.FirstName,driver.Employee?.LastName].join(' ') || ''
            this.scoreErrors.Errors = driver.DayErrors
            this.$showModal('score-errors')
        },
        updateScore(){
            this.presaving = true
            const ewtid = this.types.find(t=>t.Code == this.score.Day?.Score?.Type?.Code)?.Id || null
            EmployeeOperationsApi.Score.PreSave({
                EmployeeId:this.score.Driver?.Employee?.Id || null,
                Date:moment(this.score.Day.Date,"DD.MM.YYYY").format("YYYY-MM-DD"),
                WorkedTime: this.score.IsHTM || this.score.IsGTM 
                            ? this.score.Day.Tachograph.AllNew.OriginalTacho
                            : this.score.Day.Tachograph.AllNew.N,
                NightWorkedTime:this.score.NightWorkedTime,
                EmployeeWorkingTypeId:ewtid,
                DriverCardNumber:this.score.Driver?.DriverCardNumber || null,
                GTM:this.score.GTM || null,
                SGKEksikGunId:this.score.SGKEksikGunId || null,
                IsHTM:this.score.IsHTM,
                IsGTM:this.score.IsGTM,
                IsArife:this.score.IsArife,
                Driver:true,
                BranchId:this.score?.BranchId || null,
                SGKJobNoticeId:this.score?.SGKJobNoticeId || null,
                BranchTypeCode: this.branchType,
                DisplayMode: this.displayMode,
            }).then(res=>{
                this.presaving = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('edit-score')
                    const data = res.data.Data.Data[0]
                    if(data){
                        const index = this.serverData.findIndex(item => item.SGKJobNoticeId === data.SGKJobNoticeId)
                        if (index !== -1) {
                            this.serverData.splice(index, 1, data)
                            this.$nextTick(()=>{
                                this.firstConfigure()
                                this.checkErrors()
                            })
                        }
                    }
                    //this.getAllMonthly()
                }
            }).catch(err=>{
                this.presaving = false
                this.$result(null,err)
            })

            // const employee = this.score.Driver?.Employee || null
            // if(employee){
            //     const scoreData = this.serverData.find(d=>d.Employee?.Id == employee?.Id)
            //     if(scoreData){
            //         this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Code',this.score.Day.Score.Type.Code)
            //         this.$set(scoreData.Days[this.score.Day.Date],'Unsaved',true)
            //         this.$set(scoreData.Days[this.score.Day.Date],'Updated',true)
            //         const wts = this.types.find(t=> t.Code == this.score.Day.Score.Type.Code)
            //         if(wts){
            //             this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Color',wts.Color)
            //             this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Id',wts.Id)
            //         }else{
            //             this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Color',null)
            //             this.$set(scoreData.Days[this.score.Day.Date].Score.Type,'Id',null)
            //             this.$set(scoreData.Days[this.score.Day.Date],'Unsaved',false)
            //             this.$set(scoreData.Days[this.score.Day.Date],'Updated',false)
            //         }
            //         this.checkErrors()
            //         this.$hideModal('edit-score')
            //         this.clearForm()
            //     }
            // }
        },
        clearAdditionalForm(){
            this.additional.EmployeeId = null
            this.additional.Month = null
            this.additional.Year = null
            this.additional.Time = null
            this.additional.TIP = null
            this.additional.SIRA_NO = null
            this.additional.SystemCalculated = null
            this.additional.SystemCode = null
            this.additional.BranchId = null
        },
        editAdditional(d,tip,sira,code){
            this.clearAdditionalForm()
            this.additional.EmployeeId = d.Employee?.Id || null
            this.additional.Month = this.month
            this.additional.Year = this.year
            this.additional.TIP = tip
            this.additional.SIRA_NO = sira
            this.additional.SystemCalculated = (tip == 1 && sira==35) ? d.FM : d.HTM
            this.additional.Time = (tip == 1 && sira==35) ? d.MonthlyFM : d.MonthlyHTM
            this.additional.SystemCode = code
            this.additional.BranchId = d.OBranch?.Id
            this.additional.SGKJobNoticeId = d.SGKJobNoticeId
            this.$showModal('additional')
        },
        createAdditional(){
            this.additionalCreating = true
            EmployeeOperationsApi.Score.InsertAdditional({
                ...this.additional,
                Driver:true
            }).then(res=>{
                this.additionalCreating = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('additional')
                    this.checkUnsavedAndGetAll()
                }
            }).catch(err=>{
                this.additionalCreating = false
                this.$result(null,err)
            })
        },
        hover(event){
            let element = event.target
            let selector = element.dataset.cellGroup
            document.querySelectorAll(`[data-cell-group='${selector}']`).forEach((e,i)=>e.classList.add(`active-${i}`))
        },
        unhover(event){
            let element = event.target
            let selector = element.dataset.cellGroup
            document.querySelectorAll(`[data-cell-group='${selector}']`).forEach((e,i)=>e.classList.remove(`active-${i}`))
        },
        configureDaysOfMonth(date){
            this.daysOfMonth = []
            Array.from(Array(moment(date).daysInMonth()).keys()).forEach((d,index)=>{
                let _date = moment(date).startOf("month").add(d,'days')
                let _dateForName = _date.format('DD.MM.YYYY')
                this.daysOfMonth.push(_dateForName)
            })
        },
        getCurrentYear(){
            if(this.exitAction?.exitDate){
                this.year = moment(this.exitAction.exitDate).year()
            }else this.year = moment().format('YYYY')
            this.showingYear = this.year
        },
        configureYears(){
            let years = []
            let year = 2015
            while(year <= this.year){
                years.push(year)
                year ++
            }
            this.years = years
        },
        getCurrentMonth(){
            let current = this.exitAction?.exitDate ? (moment(this.exitAction.exitDate).month() + 1) :  (moment().month() + 1)
            this.month = this.months.find(m=>m.index == current)?.index || 0
            this.showingMonth = this.month
        },
        firstConfigure(){
            this.serverData.filter(d => !d.Configured).forEach(sd=>{
                this.$set(sd,'DayErrors',[])
                this.$set(sd,'Selected',false)
                this.$set(sd,'HasNoDriverCard',false)
                this.$set(sd,'Configured',true)
                !sd.RegisteredOnSystem ? sd.DayErrors.push({Type:'NotRegisteredOnSystem'}) : null
                Object.entries(sd.Days).forEach(([key,value])=>{
                    this.$set(value,'DailyCheckStatus',{Type:(value.DailyCheckStatus ? {...value.DailyCheckStatus} : null)})
                    if(value?.PresaveEWTCode){
                        const pwts = this.types.find(t=> t.Code == value.PresaveEWTCode)
                        if(pwts){
                            this.$set(value,'Score',{Type:{
                                Id:pwts.Id,
                                Code:pwts.Code,
                                Color:pwts.Color
                            }})
                        }
                    }else{
                        this.$set(value,'Score',{Type:{
                            Id: value.DailyCheckStatus?.Type?.Id ? value.DailyCheckStatus.Type.Id : value?.Tachograph?.Type?.Id ? value.Tachograph.Type.Id : null, 
                            Code: value.DailyCheckStatus?.Type?.Code ? value.DailyCheckStatus.Type.Code : value?.Tachograph?.Type?.Code ? value.Tachograph.Type.Code : null, 
                            Color: value.DailyCheckStatus?.Type?.Color ? value.DailyCheckStatus.Type.Color : value?.Tachograph?.Type?.Color ? value.Tachograph.Type.Color : null, 
                        }})
                    }
                    this.$set(value,'HasConflict',false)
                    this.$set(value,'Updated',false)
                    this.$set(value,'DayIsBefore',null)
                    this.$set(value,'CanEffect',null)
                    this.$set(value,'HasNoData',false)
                    this.$set(value,'Unsaved',false)
                })
            })
        },
        checkErrors(){
            this.serverData.forEach(sd=> {
                this.$set(sd,'DayErrors',[])
                !sd.RegisteredOnSystem ? sd.DayErrors.push({Type:'NotRegisteredOnSystem'}) : null
            })
            this.configureConflictErrorAnHasNoData()
            this.configureRepeatEmptyDays()
            this.configureAllDaysNotWorking()
            this.configureHasNoDriverCard()
            this.configureTachoAndWork()
        },
        configureTachoAndWork(){
            this.serverData.forEach(sd=>{
                Object.entries(sd.Days).forEach(([key,value]) => {
                    var tacho = this.$safe(value,'TachographNew.OriginalTacho')
                    var hasTacho = tacho != null && tacho != '00:00:00'
                    var score = this.$safe(value,'Score.Type.Code')
                    var presave = this.$safe(value,'PresaveEWTCode')
                    const base = presave || score
                    if(hasTacho && ['R','S','Ü','I'].includes(base)){
                        this.$set(value,'RSWarning',true)
                    }
                })
            })
        },
        configureConflictErrorAnHasNoData(){
            this.serverData.forEach(sd=>{
                Object.entries(sd.Days).forEach(([key,value])=>{
                    let tachograph = value.Tachograph?.Type?.Code ? value.Tachograph?.Type?.Code == 'O' ? null : value.Tachograph?.Type?.Code : null
                    let seyir = value.Seyir?.Type?.Code || null 
                    let dailyCheckStatus = value.DailyCheckStatus?.Type?.Code || null
                    let presave = value?.PresaveEWTCode
                    let score = value.Score?.Type?.Code ? value.Score?.Type?.Code == 'O' ? null : value.Score?.Type?.Code : null
                    if(this.exitAction != null) {
                        this.$set(value,'DayIsBefore',moment(key,'DD.MM.YYYY').isSameOrBefore(moment(this.exitAction.exitDate,'YYYY-MM-DD')))
                    }else{
                        this.$set(value,'DayIsBefore',moment(key,'DD.MM.YYYY').add(1,'days').isSameOrBefore(moment()))
                    }
                    this.$set(value,'CanEffect',value.Working && value.DayIsBefore)
                    if(tachograph || seyir || dailyCheckStatus || score){
                        this.$set(value,'HasNoData',false)
                        if(score && value.Updated){
                            this.$set(value,'HasConflict',false)
                        }else{
                            if(!presave){
                                if([tachograph,seyir,dailyCheckStatus].filter(v => v != null).filter((v,i,s)=> s.indexOf(v) === i).length > 1) {
                                    this.$set(value,'HasConflict',true)
                                    sd.DayErrors.push({Type:'Conflict',DayStart:key})
                                }else{
                                    this.$set(value,'HasConflict',false)
                                }
                            }else{
                                this.$set(value,'HasConflict',false)
                            }
                        }
                    }else {
                        this.$set(value,'HasNoData',true)
                    }
                })
            })
        },
        configureHasNoDriverCard(){
            this.serverData.forEach(sd=>{
                if(!sd?.DriverCardNumber) {
                    this.$set(sd,'HasNoDriverCard',true)
                }
            })
        },
        configureRepeatEmptyDays(){
            this.serverData.forEach(sd=>{
                Object.entries(sd.Days)
                    .map(([key,value])=>{ return { Day:key,...value } })
                    .reduce((err,day,index,arr)=>{
                        if(arr[index - 1]){
                            if(day.HasNoData == arr[index - 1].HasNoData && day.CanEffect == arr[index - 1].CanEffect && day.CanEffect){
                                err.at(-1).Count++
                                err.at(-1).DayEnd = arr[index].Day
                            }else{
                                err.at(-1).DayEnd = arr[index - 1].Day
                                err.push({CanEffect:day.CanEffect,DayStart:arr[index].Day,Value:day.HasNoData,Count:1,DayEnd:null })
                            }
                        }else{
                            err.push({CanEffect:day.CanEffect,DayStart:day.Day,Value:day.HasNoData,Count:1,DayEnd:null })
                        }
                        return err
                    },[]).filter(d=>d.Count >= 1 && d.Value && d.CanEffect).forEach(de=>{
                        sd.DayErrors.push({ Type:'RepeatEmpty',DayStart:de.DayStart,DayEnd:de.DayEnd,Count:de.Count })
                    })
            })
        },
        configureAllDaysNotWorking(){
            this.serverData.forEach(sd=>{
                let dayValues = Object.values(sd.Days)
                if(dayValues.filter(d=>!d.Working).length == Object.values(sd.Days).length){
                    sd.DayErrors.push({ Type:'NotRegisteredSgk'})
                }
            })
        },
        checkUnsavedAndGetAll(){
            return new Promise((resolve)=>{
                if(this.c_unsaved > 0){
                    this.$confirm("Tarih değiştirmek istediğinize emin misiniz?",`${this.c_month} ${this.showingYear} için toplam ${this.c_unsaved} adet kaydedilmemiş puantaj değişikliği bulunmaktadır. Devam durumunda değişiklikler kaydedilmeyecektir.`).then(result=>{
                        if(result){
                            this.getAllMonthly().then(()=>resolve(true))
                        }
                    })
                }else this.getAllMonthly().then(()=>resolve(true))
            })
        },
        selectAll(){
            (this.serverData || []).filter(sd=>sd.DayErrors.length == 0).forEach(sd=>{
                this.$set(sd,'Selected',true)
            })
        },
        getAllMonthly(){
            return new Promise((resolve)=>{
                this.loading = true
                EmployeeOperationsApi.Score.AllMonthlyNew({
                    PaginateRequest:{
                        Skip: this.currentPage,
                        Take: this.perPage,
                        QueryParam :this.searchValue || null,
                        OrderColumnName :null
                    },
                    BranchTypeCode: this.branchType,
                    BranchId:this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                    Month:this.month,
                    Year:this.year,
                    Day:1,
                    DisplayMode: this.displayMode,
                    ...(this.exitAction?.employeeId && {EmployeeId:this.exitAction?.employeeId}),
                    ...(this.exitAction?.notifyDate && {ExitNotifyDate:this.exitAction?.notifyDate}),
                    ...(this.exitAction?.exitDate && {ExitDate:moment(this.exitAction?.exitDate).format('YYYY-MM-DD')})
                }).then(res=>{
                    resolve(true)
                    this.loading = false
                    if(!res.data.Success){
                        this.$result(res)
                    }else{
                        this.serverData = res.data.Data.Data
                        this.total = res.data.Data.TotalCount
                        this.showingYear = this.year
                        this.showingMonth = this.month
                        let date = moment(this.year+'-'+this.month,'YYYY-MM')
                        this.configureDaysOfMonth(date)
                        this.firstConfigure()
                        this.checkErrors()
                    }
                }).catch(err=>{
                    this.loading = false
                    this.$result(null,err)
                })
            })
        },
        create(){
            debugger;
            this.saving = true
            const data = {
                Month:this.month,
                Year:this.year,
                Driver:true,
                Employees: this.serverData.filter(d=>d.Selected).map(d=>{
                    debugger;
                    return {
                        EmployeeId: d.Employee?.Id || null,
                        ExitDate:this.exitAction?.exitDate || null,
                        Driver: true,
                        FM: d.TotalFM || null,
                        HTM: d.TotalHTM || null,
                        GTM: d.GTM || null,
                        BranchId:d.OBranch?.Id || null,
                        SGKJobNoticeId:d.SGKJobNoticeId || null,
                        Days: Object.entries(d.Days).map(([key, value],index)=>{
                            
                            const obj = {
                                Driver:true,
                                Day:moment(key,"DD.MM.YYYY").format("YYYY-MM-DD"),
                                ScoreTaskId:value?.ScoreTaskId || null,
                                EmployeeWorkingTypeId: value?.Score?.Type?.Id || null,
                                CanEffect:value.CanEffect,
                                SGKEksikGunId:value.SGKEksikGunId,
                                KYKMs:value.KYKMs || [],
                            }
                            return obj
                        }).filter(d=>d.CanEffect)
                    }}
                )
            }
            console.log(data)
            EmployeeOperationsApi.Score.Create(data).then(res=>{
                this.$result(res)
                this.saving = false
                if(res.data.Success){
                    debugger;
                    this.getAllMonthly()
                }
            }).catch(err=>{
                this.saving = false
                this.$result(null,err)
            })
        },
        hasUnsavedItem(number){
            return this.c_unsavedItemsPage.includes(Number(number))
        },
        setTotal(value){
            this.total = value   
        },
    },
    computed:{
        c_month(){
            return this.months.find(m=> m.index == this.showingMonth)?.name || ""
        },
        c_totalError(){
            return this.serverData.reduce((sum,d)=>{
                sum += Object.values(d.Days).filter((day)=>day.HasConflict).length
                return sum
            },0)
        },
        c_unsaved(){
            return this.serverData.reduce((sum,d)=>{
                sum += Object.values(d.Days).filter((day)=>day.Unsaved).length
                return sum
            },0)
        },
        c_selected(){
            return this.serverData.filter(sd=>sd.Selected).length
        },
        c_unsavedItemsPage(){
            return this.serverData.filter(sd => Object.values(sd.Days).filter(d=>d.Unsaved).length || false).reduce((arr,sd)=>{
                const index = this.serverData.findIndex(d=>d.Employee?.Id == sd.Employee?.Id)
                if(index >= 0){
                    const page = Math.ceil((index + 1) / this.perPage)
                    arr.push(page)
                }
                return arr
            },[])
        },
        c_types(){
            return (this.types || []).filter(t => t.Code != 'K' && t.Code != 'C' && t.Code != 'Y').sort((a,b) => a.SIRA_NO - b.SIRA_NO)
        },
    },
    beforeRouteLeave (to, from,next) {
        if(this.c_unsaved > 0){
            this.$confirm("Çıkmak istediğinize emin misiniz?",`${this.c_month} ${this.showingYear} için toplam ${this.c_unsaved} adet kaydedilmemiş puantaj değişikliği bulunmaktadır. Devam durumunda değişiklikler kaydedilmeyecektir.`).then(result=>{
                if(result){
                    next()
                }else{
                    next(false)
                }
            })
        }else next()
    }
}
</script>

<style lang="scss">
@use "sass:map";

$types-bg:(
    'indigo': #8888ca,
    'pink': #a17191,
    'green': #83974a,
    'purple': #9a779b,
    'light-orange': #c1aca8,
    'dark-green': #9a997e,
    'yellow': #c7bf41,
    'red': #bc797e,
    'clean': #ffffff,
    'orange': #a87a4e,
    'teal': #8cbde5,
    'blue': #46b5d4,
    'gray': #9ea3c0,
);

$types-color:(
    'indigo': hsl(240, 38%, 33%),
    'pink': hsl(320, 20%, 21%),
    'green': hsl(76, 34%, 11%),
    'purple': hsl(298, 15%, 21%),
    'light-orange': hsl(10, 17%, 38%),
    'dark-green': hsl(58, 12%, 21%),
    'yellow': hsl(56, 54%, 19%),
    'red': hsl(356, 33%, 28%),
    'clean': hsl(0, 0%, 0%),
    'orange': hsl(29, 37%, 15%),
    'teal': hsl(207, 63%, 38%),
    'blue': hsl(193, 62%, 22%),
    'gray': hsl(231, 21%, 36%),
);

$types-bg-color:(
    'indigo': hsl(240, 38%, 65%),
    'pink': hsl(320, 20%, 53%),
    'green': hsl(76, 34%, 43%),
    'purple': hsl(298, 15%, 53%),
    'light-orange': hsl(10, 17%, 60%),
    'dark-green': hsl(58, 12%, 53%),
    'yellow': hsl(56, 54%, 51%),
    'red': hsl(356, 33%, 60%),
    'clean': hsl(0, 0%, 62%),
    'orange': hsl(29, 37%, 55%),
    'teal': hsl(207, 63%, 65%),
    'blue': hsl(193, 62%, 60%),
    'gray': hsl(231, 21%, 63%),
);

@each $class,$color in $types-bg{
    .type-#{$class}{
        background-color: $color !important;
        color: map.get($types-color,$class) !important;
    }
    .type-bg-#{$class}{
        background-color: lighten(map.get($types-bg-color,$class), 30%);
        color: map.get($types-color,$class) !important;
    }
};

.per-page span{
    font-size: 0.85rem;
}

@each $class,$color in $types-bg{
    .type-#{$class}{
        background-color: $color !important;
        color: map.get($types-color,$class) !important;

        & .daily-select{
            border-color: darken(map.get($types-bg-color,$class), 10%);
        }
    }
    .type-bg-#{$class}{
        background-color: lighten(map.get($types-bg-color,$class), 32%);
        color: map.get($types-color,$class) !important;
    }
};

.type{
    border-radius: 0.75rem;
    font-size: 0.9rem;
}

.type > div{
    height: 22px;
    font-size: 0.75rem;
    border-radius: 0.5rem;
    padding: 0 0.25rem;
    min-width: 22px;
}

.column-sticky{
    position: sticky;
    left: 0px;
    box-shadow: inset -1px 0px 0px 0px #d4d2de;
    z-index: 1;
}

.column-sticky:not(th){
    background-color: white;
}

.dark-layout .column-sticky:not(th){
    background-color: #283046 !important;
}

.dark-layout .column-sticky{
    box-shadow: inset -1px 0px 0px 0px rgb(75, 82, 103);
}


.error-marker{
    color:var(--secondary);
    border-radius: 0.25rem;
    box-shadow: inset 0 0 0 2px var(--secondary);
    padding: 0.35rem 0.5rem;
}

.cell-group{
    cursor: pointer;
}

.cell-group.score-error-0{
    border-radius: 0.25rem 0px 0px 0.25rem;
    box-shadow: inset 0 2px 0 0 var(--danger),
                inset 0 -2px 0 0 var(--danger),
                inset 2px 0 0 0 var(--danger) !important;
}
.cell-group.score-error-1{
    box-shadow: inset 0 2px 0 0 var(--danger),
                inset 0 -2px 0 0 var(--danger) !important;
}
.cell-group.score-error-2{
    border-radius: 0rem 0.25rem 0.25rem 0;
    box-shadow: inset 0 2px 0 0 var(--danger),
                inset 0 -2px 0 0 var(--danger),
                inset -2px 0 0 0 var(--danger) !important;
}

.cell-group.score-secondary-0{
    border-radius: 0.25rem 0px 0px 0.25rem;
    box-shadow: inset 0 2px 0 0 var(--secondary),
                inset 0 -2px 0 0 var(--secondary),
                inset 2px 0 0 0 var(--secondary) !important;
}
.cell-group.score-secondary-1{
    box-shadow: inset 0 2px 0 0 var(--secondary),
                inset 0 -2px 0 0 var(--secondary) !important;
}
.cell-group.score-secondary-2{
    border-radius: 0rem 0.25rem 0.25rem 0;
    box-shadow: inset 0 2px 0 0 var(--secondary),
                inset 0 -2px 0 0 var(--secondary),
                inset -2px 0 0 0 var(--secondary) !important;
}

.cell-group.score-warning-0{
    border-radius: 0.25rem 0px 0px 0.25rem;
    box-shadow: inset 0 2px 0 0 var(--yellow),
                inset 0 -2px 0 0 var(--yellow),
                inset 2px 0 0 0 var(--yellow) !important;
}
.cell-group.score-warning-1{
    box-shadow: inset 0 2px 0 0 var(--yellow),
                inset 0 -2px 0 0 var(--yellow) !important;
}
.cell-group.score-warning-2{
    border-radius: 0rem 0.25rem 0.25rem 0;
    box-shadow: inset 0 2px 0 0 var(--yellow),
                inset 0 -2px 0 0 var(--yellow),
                inset -2px 0 0 0 var(--yellow) !important;
}

.cell-group.score-info-0{
    border-radius: 0.25rem 0px 0px 0.25rem;
    box-shadow: inset 0 2px 0 0 var(--info),
                inset 0 -2px 0 0 var(--info),
                inset 2px 0 0 0 var(--info) !important;
}
.cell-group.score-info-1{
    box-shadow: inset 0 2px 0 0 var(--info),
                inset 0 -2px 0 0 var(--info) !important;
}
.cell-group.score-info-2{
    border-radius: 0rem 0.25rem 0.25rem 0;
    box-shadow: inset 0 2px 0 0 var(--info),
                inset 0 -2px 0 0 var(--info),
                inset -2px 0 0 0 var(--info) !important;
}

.cell-group.active-0{
    border-radius: 0.25rem 0px 0px 0.25rem;
    box-shadow: inset 0 2px 0 0 var(--primary),
                inset 0 -2px 0 0 var(--primary),
                inset 2px 0 0 0 var(--primary) !important;
}
.cell-group.active-1{
    box-shadow: inset 0 2px 0 0 var(--primary),
                inset 0 -2px 0 0 var(--primary) !important;
}
.cell-group.active-2{
    border-radius: 0rem 0.25rem 0.25rem 0;
    box-shadow: inset 0 2px 0 0 var(--primary),
                inset 0 -2px 0 0 var(--primary),
                inset -2px 0 0 0 var(--primary) !important;
}

.cell-group.score-ihbar-0{
    --ihbar: #F652A0;
    border-radius: 0.25rem 0px 0px 0.25rem;
    box-shadow: inset 0 2px 0 0 var(--ihbar),
                inset 0 -2px 0 0 var(--ihbar),
                inset 2px 0 0 0 var(--ihbar) !important;
}
.cell-group.score-ihbar-1{
    --ihbar: #F652A0;
    box-shadow: inset 0 2px 0 0 var(--ihbar),
                inset 0 -2px 0 0 var(--ihbar) !important;
}
.cell-group.score-ihbar-2{
    --ihbar: #F652A0;
    border-radius: 0rem 0.25rem 0.25rem 0;
    box-shadow: inset 0 2px 0 0 var(--ihbar),
                inset 0 -2px 0 0 var(--ihbar),
                inset -2px 0 0 0 var(--ihbar) !important;
}

.sticky-status{
    background-color: white;
    position: sticky;
    top: 0px;
    z-index: 10;
}
.dark-layout .sticky-status{
    background-color: #283046 !important;
}

.date-header{
    font-size: 2.5rem;
    line-height: 1.2;
}

.cell-error-indicator{
    box-shadow: inset 0 0 0 2px var(--danger);
}
.cell-warning-indicator{
    box-shadow: inset 0 0 0 2px var(--yellow);
}
.cell-info-indicator{
    box-shadow: inset 0 0 0 2px var(--info);
}
.cell-secondary-indicator{
    box-shadow: inset 0 0 0 2px var(--secondary);
}
.cell-indicator-icon{
    font-size: 16px;
}
.cell-ihbar-indicator{
    box-shadow: inset 0 0 0 2px #F652A0;
    color: #F652A0 !important;
}

.small-box{
    position: absolute;
    top: 2px;
    right: 2px;
    font-size: 0.5rem;
    padding: 0.1rem;
    font-weight: bold;
    border-radius: 0.1rem;
}
</style>